import { ActivityStatus } from "@cca/components";
import { ActivityProgressDto } from "@core/typesV2";

export const isActivityCompletedOrModified = (
  status?: ActivityStatus,
): boolean =>
  status === ActivityStatus.Completed || status === ActivityStatus.Modified;

const isActivitySubmittedOrGraded = (status?: ActivityStatus): boolean =>
  status === ActivityStatus.PendingGrade || isActivityCompletedOrModified(status);

export const isActivityGradeVisible = (
  progress?: ActivityProgressDto | null,
): boolean => isActivitySubmittedOrGraded(progress?.status);
